import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { buyerSettingsRestCrudThunksForBuyer } from '../../thunks/buyer_settings_thunks';
import { connect } from 'react-redux';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';

const BuyerNotificationsPage: React.FC<any> = ({
	getBuyerSettings,
	currentUser,
	buyerSettingsFetching,
	childRoutes,
}) => {
	useEffect(() => {
		getBuyerSettings(encodeURIComponent(currentUser.email));
	}, []);

	return buyerSettingsFetching ? (
		<PageLoadingPlaceholder />
	) : (
		<div>
			<Route
				path="/buyer/inbox"
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/buyer/inbox/overview',
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,

	buyerSettings: state.buyer_settings.detail,
	buyerSettingsFetching: state.buyer_settings.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	getBuyerSettings: (email) => dispatch(buyerSettingsRestCrudThunksForBuyer.readOne(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BuyerNotificationsPage);
